import { render } from "./ScreenShot.vue?vue&type=template&id=4c88425b&ts=true"
import script from "./ScreenShot.vue?vue&type=script&lang=ts"
export * from "./ScreenShot.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__